module.exports = __webpack_public_path__ + "img/total_users.52f5142d.png";